export const POSITION_OPTIONS = {
  LEFT: 'left',
  RIGHT: 'right',
} as const;
